import { FeberApiClient } from "../../services/commonServices"

export interface IPerson {
    city: string;
    last_name: string;
    display_name: string;
    isActive: boolean;
    engine_value: string;
    picture: string;
    phone: IPhone;
    feid: string;
    first_name: string;
    job_title: string;
    email: string;
    isFavorite: boolean;
}

export interface IPhone {
    primary: string;
    mobile: string;
}

export interface IExpertResponse {
    q: string;
    mode: string;
    page: number;
    pageSize: number;
    experts: IPerson[];
    totalExperts: number;
    totalPages: number;
    error?: string;
}
export interface ISearchOptions {
    beo_val: string[];
    country: {};
}
export interface ISearchInfo {
    found_after_filter: number;
    searched_for: number;
}

export interface IMeta {
    query: string;
    found: number;
    page: number;
    limit: number;
}

export interface ISearchExpertsReq {
    pageSize?: number;
    q?: string;
    _extra?: string;
    page?: number;
    country?: string;
    beo_val?: string;
}

export interface DocumentAttribute {
    label: string;
    hits: string[];
    hasMore: boolean;
  }
  
  export interface DocumentFields {
    [attributeKey: string]: DocumentAttribute;
  }
  
  export interface DocumentItem {
    fields: DocumentFields;
    documentUrl: string;
    documentId: string;
  }
  

// Interface for the content provider
interface IContentProvider {
    name: string;
    label: string;
}

// Main interface that combines all the above
export interface IEvidenceDetail {
    contentprovider: IContentProvider;
    totalDocuments: number;
    documents: DocumentItem[];
}

export interface IEvidenceResponse {
    evidences: IEvidenceDetail[];
}

export const searchExpert = async (request: ISearchExpertsReq) => {
    let response = await (await FeberApiClient.post("Search/SearchExpert", request)).data
    return !!response.data && JSON.parse(response.data) as IExpertResponse;
}

export const getEvidences = async (url: string) => {
    let response = await (await FeberApiClient.get("Search/GetMoreDetails", { params: { url: url } })).data
    return !!response.data && JSON.parse(response.data) as IEvidenceResponse
}
